import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Switch, Route, Redirect } from 'react-router-dom'

import {
  APPLY_DOCUMMENTS_PATH,
  APPLY_DOCUMMENTS_INFO_PATH,
  APPLY_DOCUMMENTS_UPLOAD_PATH
} from '../../../MainRoutes/constants'

import { selectApplyByParamsId } from '../../selectors'
import {
  compileDocInfoPath,
  compileDocUploadPath
} from './utils'
import documentsInfoEnhancer from './enhancers/documentsInfo'
import documentsEnhancer from './enhancers/documents'
import DocumentsInfoForm from './Forms/DocumentsInfoForm'
import DocumentsForm from './Forms/DocumentsForm'

const EnhancedDocumentsInfoForm = documentsInfoEnhancer(DocumentsInfoForm)
const EnhancedDocumentsForm = documentsEnhancer(DocumentsForm)

const mapStateToProps = createStructuredSelector({
  application: selectApplyByParamsId
})

function DocumentsRoutes({ match, application, docInfo }) {
  const shouldRedirect = (
    !application.document_info ||
    application.document_info.created_at == null
  )
  const redirectPath = shouldRedirect
    ? compileDocInfoPath({ id: application.id })
    : compileDocUploadPath({ id: application.id })

  return (
    <Switch>
      <Route
        path={APPLY_DOCUMMENTS_INFO_PATH}
        render={() => (
          <EnhancedDocumentsInfoForm application={application} />
        )}
      />
      <Route
        path={APPLY_DOCUMMENTS_UPLOAD_PATH}
        render={() => (
          shouldRedirect
            ? <Redirect to={compileDocInfoPath({ id: application.id })} />
            : <EnhancedDocumentsForm application={application} />
        )}
      />
      <Redirect from={APPLY_DOCUMMENTS_PATH} to={redirectPath} exact />
    </Switch>
  )
}

export default connect(mapStateToProps)(DocumentsRoutes)
